import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GetBlogApiData, PostPutBlogApiData} from './blogs-http-interfaces';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';

const BLOGS_API_ROUTES = {
  GET_BLOGS_ADMIN: 'landing/admin/blogs/type/:blogType',
  GET_BLOG_ADMIN: 'landing/admin/blogs/:blogId',
  GET_BLOGS_LANDING: 'landing/web/blogs/non-featured',
  GET_FEATURED_BLOGS_LANDING: 'landing/web/blogs/featured',
  GET_BLOG_LANDING: 'landing/web/blogs/:blogId',
  POST_BLOG_ADMIN: 'landing/admin/blogs',
  PUT_BLOG_ADMIN: 'landing/admin/blogs/:blogId',
  PUT_DRAFT_BLOG_ADMIN: 'landing/admin/blogs/draft/:blogId',
  DELETE_BLOG_ADMIN: 'landing/admin/blogs/:blogId',
};

@Injectable({
  providedIn: 'root'
})
export class BlogsHttpService {


  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) { }

  private getBlogsReq(urlParams: any): Observable<any> {
    const {page, blogType} = urlParams;
    let apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(BLOGS_API_ROUTES.GET_BLOGS_ADMIN, {blogType});
    apiUrl = this.generalHttpHelperService.addUrlParams(apiUrl, {page});
    return this.httpClient.get(apiUrl) as any;
  }

  getBlogs(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getBlogsReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getBlogsLandingReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(BLOGS_API_ROUTES.GET_BLOGS_LANDING, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getBlogsLanding(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getBlogsLandingReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getBlogsFeaturedReq(): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(BLOGS_API_ROUTES.GET_FEATURED_BLOGS_LANDING, {page: 1});
    return this.httpClient.get(apiUrl) as any;
  }

  getBlogsFeatured(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getBlogsFeaturedReq().subscribe((res: any) => {
        resolve(res.data);
      }, error => {
        reject(error);
      });
    });
  }

  private getBlogReq(urlParams?: Record<string, any>, isLanding = false): Observable<GetBlogApiData> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(isLanding ? BLOGS_API_ROUTES.GET_BLOG_LANDING : BLOGS_API_ROUTES.GET_BLOG_ADMIN, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getBlog(urlParams?: Record<string, any>, isLanding = false): Promise<GetBlogApiData> {
    return new Promise<GetBlogApiData>((resolve, reject) => {
      this.getBlogReq(urlParams, isLanding).subscribe((res: GetBlogApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postBlogReq(): Observable<PostPutBlogApiData> {
    return this.httpClient.post(BLOGS_API_ROUTES.POST_BLOG_ADMIN, {}) as any;
  }

  postBlog(): Promise<PostPutBlogApiData> {
    return new Promise<any>((resolve, reject) => {
      this.postBlogReq().subscribe((res: PostPutBlogApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private putBlogReq(urlParam: Record<string, any>, bodyParams: any): Observable<PostPutBlogApiData> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(bodyParams.is_saved
      ? BLOGS_API_ROUTES.PUT_BLOG_ADMIN : BLOGS_API_ROUTES.PUT_DRAFT_BLOG_ADMIN, urlParam);
    return this.httpClient.post(apiUrl, bodyParams) as any;
  }

  putBlog(urlParam: Record<string, any>, bodyParams: any): Promise<PostPutBlogApiData> {
    return new Promise<any>((resolve, reject) => {
      this.putBlogReq(urlParam, bodyParams).subscribe((res: PostPutBlogApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteBlogReq(urlParam: Record<string, any>): Observable<PostPutBlogApiData> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(BLOGS_API_ROUTES.DELETE_BLOG_ADMIN, urlParam);
    return this.httpClient.delete(url) as any;
  }

  deleteBlog(urlParam: Record<string, any>): Promise<PostPutBlogApiData> {
    return new Promise<any>((resolve, reject) => {
      this.deleteBlogReq(urlParam).subscribe((res: PostPutBlogApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
